import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  hasBooking: boolean
}

const MobileConfirmationCollapsibleCardHeader: React.FC<React.PropsWithChildren<Props>> = ({ hasBooking }) => {
  if (hasBooking) {
    return <Localized id="your-booking-details" />
  }

  return <Localized id="your-payment-details" />
}

export default MobileConfirmationCollapsibleCardHeader
